import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PlusIcon } from "../../types/PlusIcon";
import { ParticipantAnswer } from "../../types/Rows";
import AddItemModal from "../template/addItemModal";
import { ParticipantRowWithEdit } from "./participantRow";
import { addParticipant } from "../../api/reportsApi";

export const ParticipantsSectionsList = ({
  reportId,
  items,
}: {
  reportId: string;
  items: ParticipantAnswer[];
}) => {
  const queryClient = useQueryClient();

  const { mutate: addParticipantHandler } = useMutation(
    async (name: string) => addParticipant(reportId, name),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([reportId, "Participants"]);
      },
    }
  );

  return (
    <div>
      <h2 className="text-[15px] font-semibold text-[var(--sc-text)] mb-3">Lista uczestników</h2>
      <div className="rounded-[10px] border border-[var(--sc-border)] overflow-hidden">
        {/* Header */}
        <div className="flex items-center bg-[var(--sc-bg)] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.06em] text-[var(--sc-text)] border-b-2 border-[var(--sc-amber)]">
          <div className="w-[25%]">Numer uczestnika</div>
          <div className="w-[30%]">Numer zweryfikowanej wizyty/fazy leczenia</div>
          <div className="w-[15%]">SDV</div>
          <div className="w-[25%]">Komentarz</div>
          <div className="ml-auto flex items-center">
            <AddItemModal
              text="Wpisz numer uczestnika"
              saveItem={(name) => addParticipantHandler(name)}
            >
              <PlusIcon />
            </AddItemModal>
          </div>
        </div>

        {items?.length === 0 && (
          <p className="text-[13px] text-[var(--sc-muted)] px-4 py-4">Brak uczestników.</p>
        )}
        {items
          ?.sort((a, b) => (new Date(a.created) > new Date(b.created) ? 1 : -1))
          .map((item) => (
            <ParticipantRowWithEdit
              key={item.id}
              input={item}
              reportId={reportId}
            />
          ))}
      </div>
    </div>
  );
};
